export default __webpack_public_path__ + "dd1015973bc5bcdaea20940b2e4c9be1.wav";